import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";

@Component({
    selector: "app-data-grid",
    templateUrl: "./data-grid.component.html",
    styleUrls: ["./data-grid.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataGridComponent {
    @Input() dataSource: any[];
    @Input() columns: any[];
    @Input() keyExpr: string;
    @Input() selectedRowKeys: any[];
    @Input() hasSearch = true;
    @Input() hasFilter = false;
    @Input() hasExport = false;
    @Input() hasGrouping = false;
    @Input() hasColumnChooser = false;
    @Input() allowAdding = false;
    @Input() allowUpdating = false;
    @Input() allowDeleting = false;
    @Input() allowColumnReordering = false;
    @Input() allowColumnResizing = false;
    @Input() showColumnHeaders = true;
    @Input() exportFileName: string;
    @Input() groupItems: any[];
    @Input() height = "auto";
    @Input() selectionMode = "none";
    @Input() allowSelectAll = true;
    @Input() hasPaging = true;
    @Input() pageSize = 15;
    @Input() useDefaultUpdateEmitter = false;
    @Input() editMode = "row";

    @Output() initNewRow = new EventEmitter<any>();
    @Output() selectionChanged = new EventEmitter<any>();
    @Output() rowClicked = new EventEmitter<any>();
    @Output() rowDblClicked = new EventEmitter<any>();
    @Output() contextMenuPreparing = new EventEmitter<any>();
    @Output() cellPrepared = new EventEmitter<any>();
    @Output() rowInserting = new EventEmitter<any>();
    @Output() rowInsertingWithEvent = new EventEmitter<any>();
    @Output() rowUpdating = new EventEmitter<any>();
    @Output() rowUpdatingWithEvent = new EventEmitter<any>();
    @Output() rowRemoving = new EventEmitter<any>();
    @Output() rowRemovingWithEvent = new EventEmitter<any>();
    @Output() toolbarPreparing = new EventEmitter<any>();
    @Output() editingStart = new EventEmitter<any>();
    @Output() editorPreparing = new EventEmitter<any>();

    @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

    onInitNewRow(e: any): void {
        this.initNewRow.emit(e.data);
    }

    onExporting(e: any): void {
        e.fileName = this.exportFileName;
    }

    onSelectionChanged(e: any) {
        this.selectionChanged.emit(e.selectedRowsData);
    }

    onRowClicked(e: any): void {
        this.rowClicked.emit(e);
    }

    onRowDblClicked(e: any): void {
      this.rowDblClicked.emit(e);
    }

    onContextMenuPreparing(e: any): void {
      if (e.rowIndex < 0 || e.row.rowType !== "data") { return; }
      e.items = [];
      this.contextMenuPreparing.emit(e);
    }

    onCellPrepared(e: any) {
      this.cellPrepared.emit(e);
    }

    onRowInserting(e: any) {
        e.cancel = true;
        this.rowInserting.emit(e.data);
        this.rowInsertingWithEvent.emit(e);
    }

    onRowUpdating(e: any) {
        e.cancel = true;
        if (this.useDefaultUpdateEmitter) {
          this.rowUpdating.emit(e);
          return;
        }

        this.rowUpdating.emit(Object.assign(e.oldData, e.newData));
        this.rowUpdatingWithEvent.emit(e);
    }

    onRowRemoving(e: any) {
        e.cancel = true;
        this.rowRemoving.emit(e.data);
        this.rowRemovingWithEvent.emit(e);
    }

    onEditorPreparing(e: any) {
      this.editorPreparing.emit(e);
    }

    onEditingStart(e: any) {
      this.editingStart.emit(e);
    }

    selectAll() {
      this.grid.instance.selectAll();
    }
}
